import { Visibility, VisibilityOff } from "@mui/icons-material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import InfoIcon from "@mui/icons-material/Info";
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  TextField,
  Typography,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import axios from "axios";
import * as React from "react";
import { useState } from "react";
import { useNavigate } from "react-router";
import AlertComp from "./Alert";
import {
  customerLogin,
  customerRegister,
  updateShopifyDetails,
} from "./api/api";
import rightArrow from "./assests/images/newimages/icons/rightIcon.svg";

export default function LoginShopifyUser() {
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const navigate = useNavigate();
  const isStepSkipped = (step) => skipped.has(step);
  const [open, setOpen] = React.useState(false);

  // <!-----------------------------!>
  // select field state
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // select gender state
  const [alertopen, setalertopen] = useState(false);
  const [alertmsg, setalertmsg] = useState("Test");

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLoginUser = async () => {
    if (!email || !password) {
      setalertopen(true);
      setalertmsg("Please enter all the details");
      setTimeout(() => {
        setalertopen(false);
      }, 2000);
      return;
    }
    let reqBody = {
      email: email,
      password: password,
    };
    // setLoading(true);
    try {
      const response = await axios.post(customerLogin, reqBody);
      console.log(response, "::>>response>>");
      //   setLoading(false);
      if (response.status == 200) {
        setOpen(true);
        navigate("/productdetails");
        console.log(response.data.accessToken);
        localStorage.setItem("userToken", response.data.accessToken);
      }
    } catch (error) {
      console.log(error, "Error");
    }
  };

  // <!-----------------------------!>

  const handleBack = () => {
    navigate("/completeProfile");
  };

  const handleBuyNow = () => {
    navigate("/productdetails");
  };

  return (
    <div className="photo-container main-section-container healthAssessmentReportSection completeProfileSection">
      <Dialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          }
        }}
        open={open}
        className="myCustomDialog"
        disableBackdropClick
      >
        <DialogTitle>You have login successfully!</DialogTitle>
        <div className="dialogButtonWrapper">
          <button className="buyNowbtn" onClick={handleBuyNow}>
            Explore More
          </button>
        </div>
      </Dialog>
      <div className="">
        <div
          className="d-flex justify-content-start align-items-center gap-10px bgArrowDiv"
          style={{ position: "relative" }}
        >
          <span className="backButtonDiv mt-0px" onClick={() => navigate("/CompleteProfile")}>
            <ArrowBackOutlinedIcon
              className="arrowBackBtn"
            ></ArrowBackOutlinedIcon>
          </span>
          <div className="pageTitle">
            <h2 className="registerShortReportTitle">Login</h2>
          </div>
        </div>
      </div>
      <Box sx={{ width: "100%" }} className="MainStepperSection mt-20px">
        <Grid container spacing={2} mt={3} className="mt-0px">
          <Grid item xs={12} className="pt-0px pl-0px">
            <div>
              <div className="CommBgMainCard">
                <Card className="mainCardInput mt-40px">
                  <CardContent className="w-100 CardContentInput">
                    <Grid container spacing={2} className="">
                      <Grid item xs={12}>
                        <Typography
                          variant="h5"
                          className="assessmentQuestion pl-0px"
                        >
                          Enter Login Details
                        </Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          id="outlined-basic"
                          type="email"
                          label="Email"
                          variant="outlined"
                          placeholder="Email"
                          className="mainInputField"
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          id="outlined-basic"
                          //   type="password"
                          type={showPassword ? "text" : "password"}
                          label="Password"
                          variant="outlined"
                          placeholder="Password"
                          className="mainInputField"
                          onChange={(e) => setPassword(e.target.value)}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={handleClickShowPassword}
                                  edge="end"
                                >
                                  {showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} className="">
                        <p className="d-flex justify-content-start align-items-start regretPara">
                          <InfoIcon></InfoIcon>
                          We need this information to generate prescriptions and
                          delivery of approved medications in the European
                          Union.
                        </p>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </div>
            </div>
          </Grid>

          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="space-between"
            className="gap-10px"
          >
            <Button
              color="inherit"
              onClick={() => handleBack()}
              className="BorderPreviewButton"
            >
              <div className="d-flex align-items-center gap-10px">
                <img src={rightArrow} className="prevLeftarrow"></img>
                <span> Previous</span>
              </div>
            </Button>
            {/* {activeStep === 1 && (
              <Button color="inherit" onClick={handleSkip}>
                Skip
              </Button>
            )} */}
            <Button
              onClick={() => handleLoginUser()}
              className="NextViewButton"
            >
              <div className="d-flex align-items-center gap-10px">
                <span> Login</span>
                <img src={rightArrow} alt="Left Arrow" />
              </div>
            </Button>
          </Grid>
        </Grid>
      </Box>
      <AlertComp open={alertopen} msg={alertmsg} type={"error"} />
    </div>
  );
}
